module.exports = __webpack_public_path__ + "img/voltaje_a.4494f64f.svg";